<template>
  <a
    :href="url"
    target="_blank"
  >
    <font-awesome-icon
      icon="file-pdf"
      class="fa-2x"
    />
  </a>
</template>

<script>
export default {
  name: 'PdfLink',
  props: {
    url: {
      type: String,
      required: true
    }
  }
}
</script>

<style>

</style>
